import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: ReactNode;
  href?: string;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  children,
  href = 'https://theassetsvault.com/cart/53783138926902:1',
  className = '',
  onClick
}: CTAButtonProps) {
  return <motion.a href={href} onClick={e => {
    if (href?.startsWith('#')) {
      e.preventDefault();
      const target = document.querySelector(href);
      target?.scrollIntoView({
        behavior: 'smooth'
      });
    }
    onClick?.();
  }} whileHover={{
    scale: 1.02,
    boxShadow: '0px 10px 30px -10px rgba(212, 168, 83, 0.6)'
  }} whileTap={{
    scale: 0.98
  }} className={`
        inline-flex items-center justify-center text-center
        bg-gradient-to-b from-[#E5B964] to-bakery-amber 
        text-bakery-brown font-bold text-lg md:text-xl 
        px-8 py-4 md:px-10 md:py-5 rounded-full 
        shadow-lg transition-all
        hover:from-[#F0C87A] hover:to-[#E5B964]
        ${className}
      `} data-id="element-23">
      {children}
    </motion.a>;
}